export default __webpack_public_path__ + "static/media/351.4c646be3.gif";